module.exports = __webpack_public_path__ + "static/img/bg_2_7.9238306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_7.png
// module id = zqcV
// module chunks = 3